/* eslint-disable */
const urlRegex = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
/* eslint-enable */

const urlValidator = (value: string) => {
  const result = []
  if (value === '') {
    result.push('Link is vereist')
  } else if (value.match(urlRegex) === null) {
    result.push('Link is ongeldig')
  }
  return result
}

export default urlValidator
